export default __webpack_public_path__ + "static/media/not-included-cross.0780a1cd.svg";